<div class="page-wrapper">
    <div class="row tenant-wrapper" [ngClass]="houseType == 3 ? 'familyHeadBg' : 'colivHeadBg'">
        <div class="col-lg-7 col-md-10 col-sm-12 col-xs-12 logo-wrapper"  >
            <div class="tag-line-wrapper">
                <h1 class="tag-line">A Prop Tech Residential Real Estate Rental & Property Management Company.</h1>
            </div>                                  
            <div class="button-content">
                <a class="button-content-text" href="/login">Tenant Login </a>
            </div>            
            <h1 class="sub-tag-line"> Where are you looking to stays ? </h1>
        </div>  
        <div class="col-lg-5 col-md-6 d-lg-flex d-none homeowner_header_img_wrapper" [ngClass]="houseType == 3 ? 'familyBg' : 'colivBg'">
            
          </div>  
    </div>
    <div class="row search-bar-container">
        <div class="col-lg-11 col-md-11" style="padding: 0 !important">
        <ul class="nav nav-tabs house_type_tabs" id="housetypetabs" role="tablist">
            <li class="nav-item" (click)="selectHouseType(3)">
              <a class="nav-link active" id="family-tab" data-toggle="tab" role="tab" aria-controls="family"
                aria-selected="true">Family</a>
            </li>
            <li class="nav-item" (click)="selectHouseType(1)">
              <a class="nav-link" id="coliving-tab" data-toggle="tab" role="tab" aria-controls="coliving"
                aria-selected="false">Coliving</a>
            </li>
          </ul>
        </div>

        <!-- For Medium and Large devices -->
        <div class="col-lg-11 col-md-11 search-bar-wrapper search-bar-wrapper-md">
            <div class="row search-wrapper">
                <div class="col-lg-3 col-md-3 col-sm-12">
                    <div class="search-box-filter-wrapper">
                        <h1 class="search-box-city"> City </h1>
                        <select [ngModel]="(selectedCity)" (ngModelChange)="onSelectedCityChange($event)" title="city" class="city-dropdown">
                            <option *ngFor="let c of cityList" [ngValue]="c.id">{{c.text}}</option>
                        </select> 
                    </div>                    
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="search-box-filter-wrapper">
                        <h1 class="search-box-city"> Locality </h1>
                        <div class="location-input-wrapper">
                            <input  placeholder="Search Location" class="location-input" [ngModel]="selectedLocation" (ngModelChange)="selectedLocation = $event" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search/>
                            <fa-icon [icon]="faSearch" style="padding: 10px;"></fa-icon>
                        </div>                    
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 search-button-container">
                    <div class="search-button-wrapper search-button-wrapper-position" (click)="searchProperty()">
                        <p class="search-button-text" > Search </p>
                    </div>                    
                </div>
            </div>
        </div>

        <!-- For Small and Very Small Screen Devices -->
        <div class="col-12 search-bar-wrapper-sm">
            <div class="row search-inputs-wrapper-sm">
                <div class="col-sm-3 col-12 search-inputs">
                    <h1 class="search-box-city search-box-city-sm"> City </h1>
                    <select [ngModel]="(selectedCity)" (ngModelChange)="onSelectedCityChange($event)" title="city" class="city-dropdown">
                        <option *ngFor="let c of cityList" [ngValue]="c.id">{{c.text}}</option>
                    </select> 
                </div>
                <div class="col-sm-8 col-12 search-inputs">
                    <div class="search-box-filter-wrapper search-box-filter-wrapper-sm">
                        <h1 class="search-box-city search-box-city-sm"> Locality </h1>
                        <div class="location-input-wrapper-sm">
                            <input  placeholder="Search Location" class="location-input" [ngModel]="selectedLocation" (ngModelChange)="selectedLocation = $event" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search_sm/>
                            <fa-icon [icon]="faSearch" style="padding: 10px;"></fa-icon>
                        </div>                    
                    </div>
                </div>
                <div class="col-sm-12 search-inputs">
                    <div class="search-button-wrapper search-button-wrapper-sm" (click)="searchProperty()">
                        <p class="search-button-text" > Search </p>
                    </div>  
                </div>
            </div> 
        </div>
    </div>

    <!-- SECTION => Tenant Descriptions - Coliving & Family Homes -->
    <div class="tenant-description section-wrapper">
        <h1 class="tenant-headings"> Coliving & Family Homes</h1>
        <div class="row description-icons">
            <div class="col-lg-2 col-md-2 col-sm-4 col-6 description-points-wrapper">
                <div class="description-icon-wrapper close_to_work_bg">     
                </div>
                <h1 class="desc-icon-text"> Within 15 min from work </h1>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-4 col-6 description-points-wrapper">
                <div class="description-icon-wrapper desc-object-icons-wrapper safe_secure_bg">   
                </div>
                <h1 class="desc-icon-text icon"> Safe & Secure </h1>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-4 col-6 description-points-wrapper">
                <div class="description-icon-wrapper desc-object-icons-wrapper low_deposit_bg">    
                </div>
                <h1 class="desc-icon-text"> Affordable & Low Deposits </h1>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-4 col-6 description-points-wrapper">
                <div class="description-icon-wrapper wfh_bg">     
                </div>
                <h1 class="desc-icon-text"> Work from Home Friendly </h1>
            </div>
            
            <div class="col-lg-2 col-md-2 col-sm-4 col-6 description-points-wrapper">
                <div class="description-icon-wrapper desc-object-icons-wrapper onc_click_bg">     
                </div>
                <h1 class="desc-icon-text"> All-in-one Dashboard </h1>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-4 col-6 description-points-wrapper">
                <div class="description-icon-wrapper prof_mng_bg">   
                </div>
                <h1 class="desc-icon-text"> Professionally Managed </h1>  
            </div>
        </div>
        <div class="row description-wrapper">
            <div class="col-lg-10 col-md-8 col-12 description-text-wrapper">
                <h1 class="description-text">YourOwnROOM provides high quality ready to move-in professionally managed Coliving and Family rental homes that are safe, secure, comfortable, work from home friendly and strategically located for you to experience a hassle free stay. </h1>            
            </div>
        </div>        
    </div>
    <!-- SECTION : FEATURED HOMES -->
    <div class="featured-homes bg-color-wrapper section-wrapper">
        <h1 class="tenant-headings"> Featured Homes in <span style="text-transform: capitalize;"> {{ selectedCity }} </span> </h1>
        <div class="featured-home-type-tabs">
            <h1 class="home-type active" id="family" (click)="changeHomeType('family')"> Family </h1>
            <h1 class="home-type " id="coliving" (click)="changeHomeType('coliv')"> Coliving </h1>
            
        </div>
        <div class="featured-home-wrapper" id="featuredProperty_carousal" *ngIf="family == true">
            <div class="col-lg-4 col-md-6 col-sm-10 col-xs-10 featured-home-content-wrapper" *ngFor="let prop of featuredFamilyHome ">
                <div class="featured-home-card" >                    
                    <img src="{{ prop.propimage.url }}" class="featured-home-img img-responsive"  alt="Residential Real Estate Asset Management Company"/>                    
                    
                        <div class="featured-home-card-details">
                            <h1 class="featured-home-detail property-name"> {{ prop.name }} </h1>
                            <h1 class="featured-home-detail property-rent"> ₹ {{ prop.rent }} </h1>                            
                            <h1 class="featured-home-detail property-location"> 
                                <span> 
                                    <img src="assets/images/tenants/Location.png" class="location-img img-responsive"/>
                                </span>
                                {{ prop.locality }}
                            </h1>
                            <p class="button-explore" [routerLink]="['/property',prop.id]"> Explore </p>
                        </div>                    
                </div>
            </div>            
        </div>
        <div class="featured-home-wrapper" id="featuredProperty_carousal" *ngIf="coliving == true">
            <div class="col-lg-4 col-md-6 col-sm-8 col-8 featured-home-content-wrapper" *ngFor="let prop of featuredCoLivHome ">
                <div class="featured-home-card" >                    
                    <img src="{{ prop.propimage.url }}" *ngIf="prop.propimage != undefined || prop.propimage != null" class="featured-home-img img-responsive"  alt="Residential Real Estate Asset Management Company"/>  
                    <img src="assets/images/tenants/coming-soon.jpg" *ngIf="prop.propimage == undefined || prop.propimage == null" class="featured-home-img img-responsive"  alt="Residential Real Estate Asset Management Company" />                                      
                    <div class="featured-home-card-details">
                        <h1 class="featured-home-detail property-name">  {{prop.name}} </h1>
                        <h1 class="featured-home-detail property-rent"> ₹ {{ prop.rent }} </h1>                          
                        <h1 class="featured-home-detail property-location"> 
                            <span> 
                                <img src="assets/images/tenants/Location.png" class="location-img img-responsive"/>
                            </span>
                            {{ prop.locality }}
                        </h1>
                        <p class="button-explore" [routerLink]="['/property',prop.id]">EXPLORE </p>
                    </div>                    
                </div>
            </div>
        </div>
       
        
        <div *ngIf="propertyLoader == true">
            <div class="row loader-wrapper">
                <div class="col-md-4 loader-card">
                    <img src="../../assets/images/loading.gif" class="loader" />
                </div>                
            </div>            
        </div>
        <div [ngClass]="featuredCoLivHome.length > 2 ? 'showIndicators' : featuredCoLivHome.length > 3 ? 'removeIndicators' : 'removeIndicators' ">
            <div class="scroll_indicator_wrapper"  >
                <img src="assets/images/left-arrow.svg" (click)="featPropLeftIndicator()" class="scroll_indicator_video_1" alt="Residential Real Estate Asset Management Company">
                <img src="assets/images/right-arrow.svg" (click)="featPropRightIndicator()" class="scroll_indicator_video" alt="Residential Real Estate Asset Management Company">
            </div>
        </div>
    </div>

    <!-- SECTION : HASSLE FREE REAL ESTATE PLATFORM -->
    <div class="platform-offering section-wrapper">
        <h1 class="tenant-headings">Hassle Free Real Estate Platform</h1>
        <div class="row platform-wrapper">
            <div class="col-4 col-lg-3 col-md-4 mobile-img-wrapper">
                <div class="dashboard_img dashboard_img-left">
                    <img src="assets/images/tenants/mobile1.png" class="mobile-img img-responsive" alt="Residential Real Estate Asset Management Company" />
                </div>
            </div>
            <div class="col-lg-6 col-md-4 col-sm-12 col-xs-12 platform-content">
                <div>
                    <div class="platform-text-wrapper">
                        <h1 class="platform-text"> Offering end-end tenancy journey from discovery of accommodations online ,digital service request management,online rental payments.Manage your entire stay from our App/Desktop site. </h1>
                    </div>       
                    <div class="googleplay-button-wrapper">
                        <img src="assets/images/tenants/googleplay.png" class="googleplay-button img-responsive" alt="Residential Real Estate Asset Management Company" />
                    </div>         
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-12 col-xs-12 mobile-img-wrapper">
                <div class="dashboard_img dashboard_img-right">
                    <img src="assets/images/tenants/mobile2.png" class="mobile-img img-responsive" alt="Residential Real Estate Asset Management Company" />
                </div>
            </div>
        </div>

        <!-- Platform for Small Screen -->
        <div class="row platform-wrapper_sm">
            <div class="col-lg-3 col-md-4 col-sm-12 col-xs-12 mobile-img-wrapper_sm tag-margin">
                <div class="dashboard_img dashboard_img-left">
                    <img src="assets/images/tenants/mobile1.png" class="mobile-img img-responsive" alt="Residential Real Estate Asset Management Company" />
                </div>
                <div class="dashboard_img dashboard_img-right">
                    <img src="assets/images/tenants/mobile2.png" class="mobile-img img-responsive" alt="Residential Real Estate Asset Management Company" />
                </div>
            </div>            
            <div class="col-lg-6 col-md-4 col-sm-12 col-xs-12 platform-content tag-margin">
                <div class="platform-text-wrapper">
                    <h1 class="platform-text"> Offering end-end tenancy journey from discovery of accommodations online ,digital service request management,online rental payments.Manage your entire stay from our App/Desktop site. </h1>
                </div>       
                <div class="googleplay-button-wrapper tag-margin">
                    <img src="assets/images/tenants/googleplay.png" class="googleplay-button img-responsive" alt="Residential Real Estate Asset Management Company" />
                </div>         
            </div>            
        </div>
    </div>

    <!-- Testomonials -->
    <div class="testimony-section-wrapper bg-color-wrapper">
        <p [routerLink]="['/testimony']" class="viewAll">View All</p>
        <h1 class="tenant-headings"> Tenant Testimonials  </h1>   
        <h1 class="tenant-headings testimony-subheading"> Hear what some tenants have to say about us! </h1>
        <div class="testimony_container">            
            <div class="testimonial_wrapper" id="testimony_carousal">
                <div class="col-lg-4 testimonial_card_video">
                    <div class="testimonial-video-wrapper" >
                        <iframe class="video_testimony" style="width:100% ; height: 100%;" src="https://www.youtube.com/embed/XruQHJlbJO4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-lg-4 testimonial_card_video">
                    <div class="testimonial-video-wrapper" >
                        <iframe class="video_testimony" src="https://www.youtube.com/embed/IUiC2tIKkzc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%; height: 100%;" ></iframe>
                    </div>
                </div>
                <div class="col-lg-4 testimonial_card_video">
                    <div class="testimonial-video-wrapper" >
                        <iframe class="video_testimony" src="https://www.youtube.com/embed/9NpI2l7Z_Dk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%; height: 100%;" ></iframe>
                    </div>
                </div>
                
                <div class="col-lg-4 testimonial_card_video">
                    <div class="testimonial-video-wrapper" >
                        <iframe class="video_testimony" src="https://www.youtube.com/embed/0aJg1pghuf0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width: 100%; height: 100%;" ></iframe>
                    </div>
                </div>
            </div>
            <div>
                <div class="scroll_indicator_wrapper">
                    <img src="assets/images/left-arrow.svg" (click)="videoTestimonialLeft()" class="scroll_indicator_video_1" alt="Residential Real Estate Asset Management Company">
                    <img src="assets/images/right-arrow.svg" (click)="videoTestimonialRight()" class="scroll_indicator_video" alt="Residential Real Estate Asset Management Company">
                </div>
            </div>
        </div>
        
    </div>

    <!-- In The News -->
    <div class="news-section">        
        <h1 class="tenant-headings">  In the News  </h1>   
        <div class="news_details_wrapper">
            <div class="yor_news" id="news_carousal">
                <div class="news col-12 col-lg-3 col-md-4">
                    <a href="https://startupstorymedia.com/startuptv/prop-tech-is-the-new-growth-catalyst-in-residential-real-estate-prabhat-kumar-tiwary-yourownroom/" target="_blank">
                        <img src="assets/images/news/startup-story.png" alt="YourOwnROOM News" style="width: 140px;">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-md-4">
                    <a href="https://yourstory.com/2017/02/yourownrooms-mantra-for-profitable-scaling/" target="_blank">
                        <img src="assets/images/news/news_yourstory.png" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="http://bwdisrupt.businessworld.in/article/YourOwnRoom-a-750K-Seed-Funded-Co-living-Home-Rental-Company-Expands-Footprint-in-Bangalore-Pune/08-10-2018-161713/" target="_blank">
                        <img src="assets/images/news/news_full-Disrupt-logo.png" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="http://www.deccanherald.com/content/594969/yourownroom-helps-singles-find-their.html" target="_blank">
                        <img src="assets/images/news/news_deccan.jpeg" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="https://thetechpanda.com/2017/10/04/startup-millennials-apartments/" target="_blank">
                        <img src="assets/images/news/news_TheTechPanda.png" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="http://www.siliconindia.com/magazine/startup-of-the-year-special-october-2016/" target="_blank">
                        <img src="assets/images/news/news_siliconindia.gif" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="https://www.indianweb2.com/search?q=yourownroom" target="_blank">
                        <img src="assets/images/news/news_indianweb2.png" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="https://m.dailyhunt.in/news/india/english/yourstory-epaper-yourstory/amid+coronavirus+how+proptech+rental+yourownroom+is+handling+tenants+and+scaling+up+its+platform-newsid-n177954266" target="_blank">
                        <img src="assets/images/news/news_dailyhunt.png" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="https://www.onlinemarketplaces.com/?s=yourownroom" target="_blank">
                        <img src="assets/images/news/news_propertyportal.png" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="http://epaper.prabhatkhabar.com/c/10229063" target="_blank">
                        <img src="assets/images/news/news_prabhatkhabar.jpg" alt="YourOwnROOM News">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="http://www.bangaloreinsider.com/yourownroom/" target="_blank">
                        <img src="assets/images/news/bangalore-insider.png">
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="http://www.thenewsminute.com/article/new-breed-startups-wants-solve-problems-house-renters-65949" target="_blank">
                        <img src="assets/images/news/news_thenewsmnt.jpg" >
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="https://www.bitosaglobal.org/news/14654" target="_blank">
                        <img src="assets/images/news/bitosa_logo.png" >
                    </a>
                </div>
                <div class="news col-12 col-lg-3 col-xl-3 col-md-4">
                    <a href="https://paulwriter.com/paul-writer-unveiled-namma-bengaluru-hot-brands-2019/" target="_blank">
                        <img src="assets/images/news/Paulwriter.png">
                    </a>
                </div>
            </div>
        </div>
        <div>
            <div class="scroll_indicator_wrapper news-indicator">
                <img src="assets/images/left-arrow.svg" (click)="newsLeft()" class="scroll_indicator_1" alt="Residential Real Estate Asset Management Company">
                <img src="assets/images/right-arrow.svg" (click)="newsRight()" class="scroll_indicator" alt="Residential Real Estate Asset Management Company">
            </div>
        </div>
    </div>

    <!-- Blogs and Articles -->
    <div class="blog-wrapper bg-color-wrapper">        
        <h1 class="tenant-headings"> Blogs & Articles  </h1>   
        <div class="blog_container">
            <div class="blogs_wrapper" id="blogs_carousal">
                <div class="col-lg-4 blog_card" >
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="../../assets/images/guest_article_img_1.jpg" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a class="blog_head" href="http://www.businessworld.in/article/De-mystifying-REIT-Real-Estate-Investment-Trust/24-08-2021-401576/" target="_blank">De-mystifying REIT: Real Estate Investment Trust</a>
                        <p class="blog_body">Real Estate Investment Trusts (REITs) are undoubtedly the safest investment options in the Indian market today. However...</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card" >
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="../../assets/images/sachinblogjpeg.jpeg" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a class="blog_head" href="https://tail-winds.medium.com/the-end-of-real-estate-silos-welcome-surveillance-d24d749f77d8" target="_blank">Rental & Property Management Companies</a>
                        <p class="blog_body">The End of Real Estate ‘Silos’ -Welcome Surveillance...</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card" >
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="../../assets/images/griclub.jpg" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a class="blog_head" href="https://www.griclub.org/news/real-estate/rental-property-management-companies_1584.html" target="_blank">Rental & Property Management Companies</a>
                        <p class="blog_body">Real estate industry in India is expected to grow five-fold to $1 trillion by 2030 and a significant percentage of this is Residential Real Estate...</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card" >
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="../../assets/images/blog10.jpg" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a class="blog_head" href="http://www.businessworld.in/article/Decoding-Model-Tenancy-Act/09-07-2021-395999/" target="_blank">Decoding Model Tenancy Act</a>
                        <p class="blog_body">Acts like RERA and Model Tenancy are now finalized, ready to set the housing sector right. While RERA was more focused around formalizing and building trust ...</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card" >
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="https://i2.wp.com/prabhatkumartiwary.com/wp-content/uploads/2021/06/RERA-YOR.jpeg?resize=294%2C171&ssl=1" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a class="blog_head" href="http://www.businessworld.in/article/How-RERA-Is-Changing-The-Landscape-of-Residential-Real-Estate-/17-06-2021-393482/" target="_blank">How RERA Is Changing The Landscape Of Residential Real Estate?</a>
                        <p class="blog_body">With the prevailing discrepancies and issues in India's real estate sector, a concrete step was taken by the...</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card">
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="https://i1.wp.com/prabhatkumartiwary.com/wp-content/uploads/2021/03/Prabhat-guest-post-4.png?resize=400%2C250&ssl=1" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a href="https://yourstory.com/2021/01/challenges-residential-real-estate-proptech/amp" class="blog_head">The Many Challenges in Residential Real Estate</a>
                        <p class="blog_body">In the early 2000s, general euphoria engulfed the Nation, especially the youth, induced by bright new...</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card">
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="https://i1.wp.com/prabhatkumartiwary.com/wp-content/uploads/2021/03/Prabhat-gues-post-3.jpeg?resize=400%2C250&ssl=1" class="blog_img" alt="Yourownroom Guest Articles and Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a href="https://www.peoplematters.in/site/interstitial?return_to=%2Fblog%2Flife-at-work%2Fhome-is-the-defacto-workplace-and-wfh-the-new-normal-25523" class="blog_head">Home is the defacto workplace and “WFH” the new normal!</a>
                        <p class="blog_body">Did we ever think that words like “Social Distance”, “Lockdown” and “Quarantine” will become such an...</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card">
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="https://miro.medium.com/max/1494/1*6y6NCuTanOofKe9MRTh_gQ.png" class="blog_img" alt="Yourownroom Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a class="blog_head" href="https://tail-winds.medium.com/the-return-of-indian-residential-real-estate-2dc01ff4b656" target="_blank">The Return of Indian Residential Real Estate</a>
                        <p class="blog_body">The property rates in India between 2000–2010 grew by 52%( in leading 7 cities). Decade after that it has grown only by 32% […]</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card">
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="https://yourownroom.com/blog/wp-content/uploads/2020/03/The-outbreak-of-the-coronavirus-and-preventive-measures-that-one-should-follow.png" class="blog_img" alt="Yourownroom Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a href="https://yourownroom.com/blog/outbreak-coronavirus-preventive-measures-one-follow/" class="blog_head">The Outbreak Of the Coronavirus and Preventive Measures</a>
                        <p class="blog_body">From dropped conferences to shutdowns of hardware suppliers, the deadly […]</p>
                    </div>
                </div>
                <div class="col-lg-4 blog_card">
                    <div class="blog_img_wrapper">
                        <div class="blog_img_inner_wrapper">
                        <img src="https://yourownroom.com/blog/wp-content/uploads/2019/12/Untitled.jpg" class="blog_img" alt="Yourownroom Blogs">
                        </div>
                    </div>
                    <div class="blog_detail">
                        <a href="https://yourownroom.com/blog/your-own-room-indias-co-living-market/" class="blog_head">What Takes YourOwnRoom to India’s $6.5B Co-Living Market</a>
                        <p class="blog_body">India’s rapidly growing co-living market is currently valued at $6.5 billion, and is […]</p>  
                    </div>
                </div>
            </div>
        </div>
        <div >
            <div class="scroll_indicator_wrapper">
                <img src="assets/images/left-arrow.svg" (click)="blogLeft()" class="scroll_indicator_blog_1" alt="Residential Real Estate Asset Management Company">
                <img src="assets/images/right-arrow.svg" (click)="blogRight()" class="scroll_indicator_blog" alt="Residential Real Estate Asset Management Company">
            </div>
        </div>        
    </div>
    
    
</div>